import { Component, Input, OnInit } from '@angular/core';
import { RoutingAuthenticationService } from '../../services/routing-authentication';
import { AuthenticationService } from '../../services/authentication.service';
import { Router } from '@angular/router';
import { Configuration } from '../../configurations/shared.config';
 
@Component({
    moduleId: module.id,
    selector: 'home-component',
    template: ``
})
export class HomeComponent implements OnInit{


    constructor(private router: Router, private auth: AuthenticationService, private routerAuth: RoutingAuthenticationService) {


    }

   async ngOnInit(){

    await this.routerAuth.init();

    if (!this.auth.isLogged) {
        this.router.navigateByUrl(Configuration.paths.loginUrl);
    } else {
        this.routerAuth.defaultPage()
            .then(page => {
                if (page) {
                    //grt the graph modules and Pages 
                    let graph = Configuration.modulesPagesGraph;
                    let Defaultmodule = graph.filter(function (item) {
                        return item.value === page;
                    });

                    //get the default modules pages 
                    if (Defaultmodule.length > 0) {
                        let pagesDefaultModule = Defaultmodule[0].page;
                        if (pagesDefaultModule) {

                            for (let i = 0; i < pagesDefaultModule.length; i++) {
                                if (this.allowedPages[pagesDefaultModule[i].value]) {
                                    //if thier an page from the module is in the allow page make it 
                                    //the default page 
                                    page = Defaultmodule[0].url + pagesDefaultModule[i].url;
                                    break;
                                }
                            }
                        }
                        this.router.navigateByUrl(page);
                    }
                    else {
                        console.log("default module is 0");
                      //  this.auth.isLogged = false;
                     //   this.router.navigateByUrl(Configuration.paths.loginUrl);

                    }
                } 
                else {
                    //Redirect to No Permission page

                }
            })
        }
    }

    get allowedPages(){
        return this.routerAuth.allowedPages;
    }
}




// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/Home/home.component.ts